import { createClient } from '@/shared/api';
import type { StopStudyMutation, StopStudyMutationVariables } from '@/shared/api';
import STOP_STUDY_MUTATION from '../mutations/stopStudy';

/**
 * Stops an in-progress study addressed by its facility study id. Runs STOP_STUDY_MUTATION and throws stopStudy.message when isSuccess is absent or false.
 *
 * @param studyFid - Facility study identifier of the study to stop.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleStopStudy = async (studyFid: any) => {
  const client = createClient();
  const stopStudyResult = await client.mutate<StopStudyMutation, StopStudyMutationVariables>({
    mutation: STOP_STUDY_MUTATION,
    variables: {
      studyFid,
    },
  });
  const { data } = stopStudyResult;
  const { stopStudy } = data ?? {};
  if (!stopStudy?.isSuccess) {
    throw new Error(stopStudy?.message ?? undefined);
  }
};

export default handleStopStudy;
